import { IDashboardRowFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { byTypeName } from '../../../utils/types';

const getDashboardAnalysesIds = (rows: IDashboardRowFieldsFragment[]) =>
  rows.flatMap((singleRow) =>
    singleRow.columns
      .filter(byTypeName('DashboardAnalysisColumn'))
      .map(({ analysis: { id } }) => id),
  );

export default getDashboardAnalysesIds;
